import { Routes } from '@angular/router';

// component nicht über index laden, ergibt runtime fehler
import { InventoryComponent } from './inventory.component';
import { ArticleDetailComponent } from './article-detail/article-detail.component';
import { AuthGuard } from '../services/index';

export const inventoryRoutes: Routes = [
    { path: 'inventory', component: InventoryComponent, canActivate: [AuthGuard]  },
    { path: 'article/:id', component: ArticleDetailComponent, canActivate: [AuthGuard]  }
];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/inventory/inventory.routes.ts